<ng-container [ngSwitch]="type" [formGroup]="group" *ngIf="!hidden || showHidden">

  <mat-form-field *ngSwitchCase="FormFieldType.Text" class="w-full" floatLabel="auto" color="accent">
    <mat-label>{{ label }}</mat-label>
    <textarea matInput formControlName="value" cdkTextareaAutosize minRows="3" maxRows="10"></textarea>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="valueCtrl?.invalid && (valueCtrl?.dirty || valueCtrl?.touched)">
      <ng-container *ngFor="let msg of getErrorMessages()">
        {{ msg }}
      </ng-container>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="mb-2 w-full" *ngSwitchCase="FormFieldType.Date" floatLabel="auto" color="accent">
    <input matInput formControlName="value" [matDatepicker]="picker">

    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="valueCtrl?.invalid && (valueCtrl?.dirty || valueCtrl?.touched)">
      <ng-container *ngFor="let msg of getErrorMessages()">
        {{ msg }}
      </ng-container>
    </mat-error>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker  #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="FormFieldType.Select" class="w-full" floatLabel="auto" color="accent">
    <mat-label>{{label}}</mat-label>
    <mat-select formControlName="value">
      @for (option of selectOptions?.selectableOptions; track option) {
        <mat-option [value]="option.value">{{option.label}}</mat-option>
      }
    </mat-select>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="valueCtrl?.invalid && (valueCtrl?.dirty || valueCtrl?.touched)">
      <ng-container *ngFor="let msg of getErrorMessages()">
        {{ msg }}
      </ng-container>
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="FormFieldType.Time" class="w-full" floatLabel="auto" color="accent">
    <mat-label>{{label}}</mat-label>
    <input matInput formControlName="value" [format]="24" [ngxTimepicker]="picker" [min]="'00:00'" [max]="'23:59'">
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <ngx-material-timepicker #picker [format]="24"></ngx-material-timepicker>
    <mat-error *ngIf="valueCtrl?.invalid && (valueCtrl?.dirty || valueCtrl?.touched)">
      <ng-container *ngFor="let msg of getErrorMessages()">
        {{ msg }}
      </ng-container>
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="FormFieldType.Number" class="w-full" floatLabel="auto" color="accent">
    <mat-label>{{ label }}</mat-label>
    <input matInput type="number" formControlName="value">
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="valueCtrl?.invalid && (valueCtrl?.dirty || valueCtrl?.touched)">
      <ng-container *ngFor="let msg of getErrorMessages()">
        {{ msg }}
      </ng-container>
    </mat-error>
  </mat-form-field>

  <div class="col-span-2" *ngSwitchCase="FormFieldType.PhotoPicker">
    <div>
      <mat-label>{{label}}:</mat-label>
      <p-carousel
        *ngIf="!isLoadingImg && getImgObj(uniqueKey).length != 0 && !IsNew"
        [value]="getImgObj(uniqueKey)"
        [numVisible]="3"
        [numScroll]="1"
        [circular]="false"
        [showNavigators]="shouldShowNavigators(getImgObj(uniqueKey))"
        [responsiveOptions]="responsiveOptions"
        [autoplayInterval]="0"
        class="w-full"
      >
        <ng-template pTemplate="item" let-item>
          <div (click)="openLightbox(item)" class="m-2 p-5 relative flex justify-center items-center w-full h-64 overflow-hidden cursor-pointer">
            <img
              [src]="item.image"
              alt="carousel image"
              class="object-cover"
            />
          </div>
        </ng-template>
      </p-carousel>
      <p class="font-bold" *ngIf="getImgObj(uniqueKey).length == 0 && !IsNew">{{ 'AUDIT.NO_IMAGES_YET' |translate }}</p>
      <p class="font-bold" *ngIf="IsNew">{{ 'AUDIT.CREATE_ENTRY_TO_UPLOAD' |translate }}</p>

      <button mat-stroked-button *ngIf="!IsNew" class="mb-4" (click)="triggerUpload.emit(uniqueKey)">{{ "AUDIT.UPLOAD" | translate }}</button>
      <p><mat-divider></mat-divider></p>
    </div>
  </div>

  <mat-checkbox *ngSwitchCase="FormFieldType.Checkbox" formControlName="value" class="w-full">
    {{ label }}
  </mat-checkbox>

  <div *ngSwitchCase="FormFieldType.Divider" class="w-full py-2">
    <p *ngIf="label" class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">{{ label }}</p>
    <mat-divider></mat-divider>
  </div>

  <div class="color-error" *ngSwitchDefault>
    <em class="color-error">{{ 'ERROR.FORM_KEY' | translate }}</em>
  </div>

  <!-- Sits below the field so it reads as an additional line under a possible
       mat-hint and does not push the field out of line with its grid neighbour. -->
  <div *ngIf="hidden && showHidden"
       class="flex items-center gap-1 text-xs font-medium text-amber-600 mt-1">
    <mat-icon class="!text-base !w-4 !h-4 leading-none">visibility_off</mat-icon>
    In der App nicht sichtbar
  </div>

</ng-container>
